// 公共变量

var logoUrl = 'https://www.wkcad.com'
var headerTitle = '悟空云-在线CAD-2D/3D都能用'

export default {
  logoUrl,
  headerTitle
}